// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"755":"e9f5b2cc","851":"a9ab26e9"}[chunkId] + ".chunk.js";
};